var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.noRecordsMessage))]),_vm._v(" "),(_vm.noRecordsButtonLabel && _vm.noRecordsButtonAction)?_c('button',{staticClass:"btn btn-sm btn-outline-success mt-3",on:{"click":_vm.noRecordsButtonAction}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n    "+_vm._s(_vm.noRecordsButtonLabel)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9d2508","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/NoRecordsFound.vue
// module id = null
// module chunks = 